// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__13yK7","error":"Textarea_error__3i_Lt","readonly":"Textarea_readonly__1AFIt","disabled":"Textarea_disabled__2LJet"};